import React, { useMemo } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';

import { analyticsIds } from '../../../../constants/analyticsIds';
import { getRowValue } from '../../../../utils/tableUtil';

const InsuredCell = ({ row, value: insured, column }) => {
  const { url } = useRouteMatch();
  const job = getRowValue(row, 'job');
  const company = getRowValue(row, 'company');
  const record = getRowValue(row, 'insuranceRequirement');

  const ippUrl = useMemo(() => {
    const baseUrl = `companies/${company.id}/insureds/${insured.id}`;

    if (record && record?.parent_type === 'insured') {
      return `${baseUrl}/records/${row.original?.id}`;
    }

    return baseUrl;
  }, [row]);

  const showJobName = column?.showJobName;

  return (
    <Box _hover={{ fontWeight: '500' }} maxW="200px">
      <Link
        data-analytics-id={analyticsIds.reportsPage.insuredProfileNameLink}
        rel="noreferrer"
        style={{
          _hover: { textDecoration: 'none', outline: 'none' },
          textDecoration: 'none'
        }}
        target="_blank"
        title={insured.externalId || insured.id}
        to={url.replace(/companies.*/, ippUrl)}
      >
        <Text color="greyScale.900">{insured.companyName}</Text>
        {showJobName && <Text color="greyScale.600">{job.name}</Text>}
      </Link>
      <Text color="grey">{getRowValue(row, 'insuredDescription')}</Text>
    </Box>
  );
};

export default InsuredCell;
